module.exports = __webpack_public_path__ + "img/jumpseller_3.78b76a4e.png";